import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'view-action-button',
    templateUrl: './view-button.component.html',
    styleUrls: ['./view-button.component.scss'],
    standalone: true
})
export class ViewButtonTableComponent implements OnInit {
    @Input() idEntity: string;
    @Output() viewEvent = new EventEmitter();

    constructor() { }

    ngOnInit() {
    }

    viewRoute() {
        this.viewEvent.emit(this.idEntity);
    }

}
